/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


import {ContextNodeChildrenList} from "./ContextNodeChildrenList";

export const SubProgramContextNodeChildrenList = (props) => {
    return <ContextNodeChildrenList
        title={"Sub-Programs"}
        {...props}
    />;
}
